import styled from "styled-components";
import { colorV2, media, typographyV2 } from "../../../../constants/styles";
import { ProjectInfo, ProjectInvolve } from "../../../../constants/projects";
import ButtonV2 from "../../../Button/ButtonV2";
import { ReactComponent as WhiteArrowRight } from "../../../../svgs/arrow-right_white.svg";
import { Link } from "react-router-dom";

interface Props {
  info: ProjectInvolve;
  interviewLink?: string;
}
const ProjectInvolveInfo: React.FC<Props> = ({ info, interviewLink }) => {
  const renderContent = ({ key, names }: {
    key: keyof ProjectInfo['involve'];
    names: string[]
  }) => {
    switch (key) {
      case 'pm':
        return (<InfoBox key={key}>
          <p>Project Manager</p>
          <p>{names.join(', ')}</p>
        </InfoBox>)
      case 'designer':
        return (<InfoBox key={key}>
          <p>UXUI Designer</p>
          <p>{names.join(', ')}</p>
        </InfoBox>)
      case 'fe':
        return (<InfoBox key={key}>
          <p>Frontend Developer</p>
          <p>{names.join(', ')}</p>
        </InfoBox>)
      case 'be':
        return (<InfoBox key={key}>
          <p>Backend Developer</p>
          <p>{names.join(', ')}</p>
        </InfoBox>)
      default:
        return null
    }
  }


  return (
    <Container backgroundColor={'#fff'}>
      <ContentContainer>
        {Object.entries(info).map(([key, value]) => renderContent({
          key: key as keyof ProjectInfo['involve'],
          names: value
        }))}
      </ContentContainer>
      {interviewLink && <Link to={interviewLink} target="_blank"><Button theme='sub' label={
        <>
          스쿼드 인터뷰 보기
          <WhiteArrowRight style={{ marginLeft: '16px' }} width={32} height={32} />
        </>
      }
      /></Link>}
    </Container>
  )
};

export default ProjectInvolveInfo

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap:42px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  ${media.MOBILE} {
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
  }
`;
const Container = styled.div<{ backgroundColor: string }>`
  background-color:${({ backgroundColor }) => backgroundColor};
  padding: 80px 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px;

  ${media.TABLET} {
    padding: 60px 48px;
  }
  ${media.MOBILE} {
    padding: 40px 24px;
    gap: 32px;
  }
`;
const InfoBox = styled.div`
  display: flex;
  flex-direction: row;
  word-break: keep-all;

  color: ${colorV2.GRAY_05};
  p:first-child {
    flex:1;
    opacity: 0.8;
    ${typographyV2.BODY_5_M};
    font-weight: 500;
  }

  p:nth-child(2) {
    flex:1;
    ${typographyV2.HEADING_7_B}; 
  }

  ${media.TABLET} {
    flex-direction: column;
    gap: 8px;
  }
  ${media.MOBILE} {}
`;

const Button = styled(ButtonV2)`
${media.MOBILE} {
  padding: 12px 32px;
  ${typographyV2.BODY_8_M}
}
`;
